export default "__VITE_ASSET__hQhF1KHx__"